import React, { useEffect, useRef, useState, useCallback } from "react";
import Select from "react-select";
import { BASE_URL } from "./Url";
import axios from "axios";
import placeholder from "../../assets/Img/placeholderproduct.jpg";

const Checkbox = React.memo(({ style = {}, ...props }) => (
  <input
    style={{ transform: "scale(1.3)", ...style }}
    type="checkbox"
    {...props}
  />
));

const SelectOpenWithPagginationDynamic = ({
  handleMultiInputChange,
  inputProduct,
  ProductsList,
  defaultValue,
  searchProductLabel,
  setSearchProductLabel,
  setProductsList,
  inputQuery,
  url1,
  url2,
  selectAll,
}) => {
  const ref = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [next, setNext] = useState(null);

  const toggleMenuIsOpen = useCallback(() => {
    setMenuIsOpen((value) => !value);
    const selectEl = ref.current;
    if (!selectEl) return;
    menuIsOpen ? selectEl.blur() : selectEl.focus();
  }, [menuIsOpen]);

  const transformProductData = useCallback(
    (product) => ({
      label: `${product.name} [[${product?.sku}]]`,
      value: product.id,
      price: product.price,
      discount: product.discount,
      stock: product.stock,
      variant: product.variants,
      thumb: product.thumb_url,
      image: product?.thumb_resized_url || placeholder,
    }),
    []
  );

  const fetchProducts = useCallback(
    async (url, append = false) => {
      if (!url) return;

      setLoading(true);
      try {
        const res = await axios.get(url);
        const { results, next: nextUrl } = res.data.data;
        const options = results.map(transformProductData);

        setProductsList((prev) => (append ? [...prev, ...options] : options));
        setNext(nextUrl);
      } catch (err) {
        console.error("Error fetching product list:", err);
      } finally {
        setLoading(false);
      }
    },
    [transformProductData, setProductsList]
  );

  const getProductList = useCallback(() => {
    if (inputQuery?.length > 1) {
      const url = !inputQuery ? `${BASE_URL}${url1}` : `${BASE_URL}${url2}`;
      fetchProducts(url);
    }
  }, [inputQuery, url1, url2, fetchProducts]);

  const handleLoadMore = useCallback(() => {
    if (next) fetchProducts(next, true);
  }, [next, fetchProducts]);

  useEffect(() => {
    const timeoutId = setTimeout(getProductList, 1000);
    return () => clearTimeout(timeoutId);
  }, [inputQuery, getProductList]);

  useEffect(() => {
    if (ProductsList?.length > 0) {
      setMenuIsOpen(true);
    }
  }, [ProductsList]);

  const CustomOption = React.memo(({ innerRef, innerProps, data }) => (
    <div
      ref={innerRef}
      {...innerProps}
      className="custom-option"
      style={{ display: "flex", alignItems: "center", height: "35px" }}
    >
      <img
        src={data.image}
        alt=""
        style={{ width: "30px", margin: "0 10px" }}
      />
      <span style={{ cursor: "pointer" }}>{data.label}</span>
    </div>
  ));

  const filteredValue =
    searchProductLabel && defaultValue
      ? defaultValue.filter((obj) =>
          obj.label.toLowerCase().includes(searchProductLabel)
        )
      : defaultValue;

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "blue" : "black",
      boxShadow: state.isFocused ? "0 0 0px 0.5px rgba(255, 0, 0, 1)" : "none",
      "&:hover": { borderColor: "blue" },
      maxHeight: "120px",
      overflowY: "auto",
    }),
    multiValueContainer: (base) => ({
      ...base,
      overflowY: "auto",
      maxHeight: "120px",
      display: "flex",
      flexWrap: "wrap",
    }),
  };

  const handleChange = (newSelectedValues, actionMeta) => {
    if (actionMeta.action === "remove-value") {
      const updatedList = defaultValue
        ? defaultValue.filter(
            (item) => item.label !== actionMeta.removedValue.label
          )
        : [];
      handleMultiInputChange(updatedList);
    } else if (actionMeta.action === "select-option") {
      if (setSearchProductLabel) {
        setSearchProductLabel("");
      }
      handleMultiInputChange(newSelectedValues);
    } else if (actionMeta.action === "clear") {
      handleMultiInputChange([]);
    } else {
      // Handle other cases like 'create-option' or direct selection
      handleMultiInputChange(newSelectedValues);
    }
  };

  return (
    <div className="main-select">
      <div
        className="my-2 d-flex justify-content-between align-items-center gap-3"
        style={{ minHeight: 36 }}
      >
        <div>
          <Checkbox
            checked={menuIsOpen}
            onChange={toggleMenuIsOpen}
            id="cypress-single__clearable-checkbox"
          />
          <span className="ms-2">{menuIsOpen ? "Close" : "Open"}</span>
        </div>
        {next && (
          <button
            className="btn btn-danger"
            onClick={handleLoadMore}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        )}
      </div>

      <div className="custom-menu">
        <Select
          ref={ref}
          components={{ Option: CustomOption }}
          menuIsOpen={menuIsOpen}
          isMulti
          placeholder="---Select---"
          isClearable
          onChange={handleChange}
          onInputChange={inputProduct}
          options={ProductsList}
          value={menuIsOpen ? defaultValue : filteredValue}
          styles={selectStyles}
        />
      </div>
    </div>
  );
};

export default React.memo(SelectOpenWithPagginationDynamic);
